import { flexStyle } from 'components/common/Common';
import { motion } from 'framer-motion/dist/framer-motion';
import { vw } from 'pages/affiliatePartner/AffiliatePartner.style';
import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

const EmptyLeg = styled.div`
  --card-min-width: 279px;

  min-width: var(--card-min-width);
  width: calc((100vw - var(--home-section-padding) - ${vw(64)}) / 3);
  border-radius: 8px;
  //! for border-radius to work
  overflow: hidden;
  padding: 16px;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 757px) {
    width: var(--card-min-width);
  }
`;

const EmptyLegLink = styled(Link)`
  position: relative;
  cursor: pointer;
  line-height: normal;
  display: flex;
  flex-direction: column;
  height: 100%;
  @media (max-width: 757px) {
    min-width: var(--card-min-width);
    height: 224px;
    & > img {
      filter: brightness(0.6);
      position: absolute;
      height: 149px;
    }
  }
`;

const CardImg = styled.img`
  border-radius: 4px;
  width: 100%;
  height: 200px;
  object-fit: cover;
  margin-bottom: 24px;
`;

const CardBody = styled.div`
  position: relative;
  font-size: var(--fs-800);
  flex: 1;
  display: flex;
  flex-direction: column;
  @media (max-width: 757px) {
    background-color: transparent;
    z-index: 2;
    color: #fff;
    font-size: 18px;
    padding-top: 32px;
    padding-bottom: 32px;

    height: 149px;
  }
`;

const Location = styled.div`
  ${flexStyle}
  ${flexGap('8px')}
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

const DateBody = styled.div`
  margin-top: 16px;
  font-weight: var(--fw-normal);
  font-size: var(--fs-400);
  display: flex;
  justify-content: space-between;
`;

const CardFooter = styled.button`
  width: 100%;
  height: 53px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1f68db;
  border-radius: 4px;
  color: #fff;
  ${flexGap('8px')}
  margin-top: 48px;
  cursor: pointer;

  span {
    font-size: 16px;
    font-weight: 400;
  }
`;

const PlaneIcon = styled.img`
  display: inline-block;
  width: 24px;
  position: relative;
  z-index: 2;

  @media (max-width: 757px) {
    filter: invert(100%);
  }
`;

const Price = styled.div`
  display: flex;
  align-items: center;
  ${flexGap(vw(4))};
  font-size: 24px;
  font-weight: 500;

  & > img {
    display: inline-block;
    width: 40px;
    height: 40px;
  }

  & > div {
    display: inline-flex;
    flex-direction: column;
    ${flexGap('4px')};

    & > span:first-child {
      font-weight: var(--fw-normal);
      font-size: var(--fs-400);
    }
  }

  @media (max-width: 757px) {
    & > img {
      width: 32px;
      height: 32px;
    }
  }
`;

const City = styled.div`
  display: flex;
  flex-direction: column;
  ${flexGap('16px')}
  font-weight: 500;
  font-size: 24px;
  color: #050a30;
  position: relative;
  z-index: 2;
  background-color: #f4f6fc;
  padding: 2px 4px;
  margin: -2px -4px;
`;

const PlaneBox = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  padding: 0 8px;
  z-index: 1;
`;

const DashedLine = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
  border-top: 1px dashed #dde2e4;
  transform: translateY(-50%);
  z-index: 0;
  pointer-events: none;
  overflow: hidden;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -2px;
    width: calc(50% - 30px);
    height: 5px;
    background-color: #f4f6fc;
    z-index: 1;
  }

  &::before {
    left: 0;
  }

  &::after {
    right: 0;
  }
`;

const Date = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #050a30;
`;

const EmptyLegLinkComponent = forwardRef((props, ref) => <EmptyLegLink ref={ref} {...props} />);
EmptyLegLinkComponent.displayName = 'EmptyLegLinkComponent';
const MotionLinkComponent = motion(EmptyLegLinkComponent);

const Card = ({ item }) => {
  return (
    <EmptyLeg>
      <MotionLinkComponent
        to={{
          pathname: item.path,
          state: item,
        }}
      >
        <CardImg src={item.picture} alt="city" />
        <CardBody>
          <Location>
            <DashedLine />
            <City>{item.startCity}</City>
            <PlaneBox>
              <PlaneIcon
                src={'/imgs/svg/home/raw-plane-icon.svg'}
                alt="plane-icon"
                height={24}
                width={24}
              />
            </PlaneBox>
            <City>{item.endCity}</City>
          </Location>

          <DateBody>
            <Date>{item.startDate}</Date>
            <Date>{item.endDate}</Date>
          </DateBody>
        </CardBody>
        <CardFooter>
          <span>From</span>
          <Price> $ {item.price}</Price>
        </CardFooter>
      </MotionLinkComponent>
    </EmptyLeg>
  );
};

export default Card;
